// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"045b740f","453":"f4b86674"}[chunkId] + ".chunk.js";
};